export const SET_TEAM_URL_PARAM_NAME = 'set_team_id'
